export default function initFiltersDownloads() {

    if (!document.body.classList.contains('post-type-archive-download')) {
        return;
    }

    const filtersAside = document.querySelector('.c-filters');
    const aspContainer = document.querySelector('.c-grid-area__asp-hidden');

    if (!filtersAside || !aspContainer) return;

    const openBtn = document.querySelector('.c-grid-area__mobile-toggle');
    const closeBtn = document.querySelector('.c-filters__close');
    const applyBtn = document.querySelector('.c-filters__apply');
    const clearBtns = document.querySelectorAll('.c-filters__clear');
    const accordionBtns = document.querySelectorAll('.c-filters__accordion-btn');
    const tabBtns = document.querySelectorAll('.c-filters__tab-btn');
    const panels = document.querySelectorAll('.c-filters__panel');
    const filterInputs = document.querySelectorAll('.c-filter-item input');
    const countDisplay = document.querySelector('.js-filter-count');

    // Captura o ID dinamicamente do HTML
    const aspId = parseInt(aspContainer.getAttribute('data-asp-id'), 10);

    // --- FUNÇÕES DE AUXÍLIO ---

    const toggleBodyScroll = (lock) => {
        document.documentElement.style.overflow = lock ? 'hidden' : '';
        document.body.style.overflow = lock ? 'hidden' : '';
        document.body.style.touchAction = lock ? 'none' : '';
    };

    const updateFilterCount = () => {
        const checkedCount = document.querySelectorAll('.c-filter-item input:checked').length;
        if (countDisplay) countDisplay.textContent = checkedCount;
    };

    const syncWithASP = (input, triggerChange = true) => {
        const value = input.value;

        // Extrai o slug da taxonomia do atributo name original
        let taxSlug = input.name.replace('termset_', '').replace('[]', '');

        // Busca o input dentro do ASP
        let aspInput = aspContainer.querySelector(`input[name*="${taxSlug}"][value="${value}"]`);

        // Fallback agressivo
        if (!aspInput) {
            const aspTaxContainer = aspContainer.querySelector(`[class*="${taxSlug}"]`);
            if (aspTaxContainer) {
                aspInput = aspTaxContainer.querySelector(`input[value="${value}"]`);
            }
        }

        if (aspInput) {
            aspInput.checked = input.checked;

            if (triggerChange) {
                aspInput.dispatchEvent(new Event('input', { bubbles: true }));
                aspInput.dispatchEvent(new Event('change', { bubbles: true }));

                const aspLabel = aspInput.closest('label') || aspInput.nextElementSibling;
                if (aspLabel && aspLabel.tagName === 'LABEL') {
                    // aspLabel.click();
                }
            }
        } else {
            console.warn(`ASP Sync Fail: Não encontrou o termo ${value} para a taxonomia ${taxSlug} no formulário oculto do ASP.`);
        }
    };

    // --- EVENTOS ---

    accordionBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            if (window.innerWidth < 992) return;

            const panel = btn.closest('.c-filters__panel');
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';

            btn.setAttribute('aria-expanded', !isExpanded);
            panel.classList.toggle('is-open');
        });
    });

    openBtn?.addEventListener('click', () => {
        filtersAside.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        toggleBodyScroll(true);
    });

    const closeFilters = () => {
        filtersAside.setAttribute('aria-hidden', 'true');
        openBtn?.setAttribute('aria-expanded', 'false');
        toggleBodyScroll(false);
    };

    closeBtn?.addEventListener('click', closeFilters);

    tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetId = btn.getAttribute('aria-controls');

            tabBtns.forEach(b => {
                b.classList.remove('c-filters__tab-btn--active');
                b.setAttribute('aria-selected', 'false');
            });
            panels.forEach(p => p.classList.remove('c-filters__panel--active'));

            btn.classList.add('c-filters__tab-btn--active');
            btn.setAttribute('aria-selected', 'true');
            document.getElementById(targetId)?.classList.add('c-filters__panel--active');
        });
    });

    filterInputs.forEach(input => {
        input.addEventListener('change', () => {
            syncWithASP(input, true);
            updateFilterCount();

            if (window.innerWidth >= 992) {
                if (window.ASP && window.ASP.api) {
                    window.ASP.api(aspId, 'search');
                }
            }
        });
    });

    applyBtn?.addEventListener('click', () => {
        if (window.ASP && window.ASP.api) {
            window.ASP.api(aspId, 'search');
        }
        closeFilters();
    });

    clearBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            let hasChanges = false;
            filterInputs.forEach(input => {
                if (input.checked) {
                    input.checked = false;
                    syncWithASP(input, true);
                    hasChanges = true;
                }
            });

            updateFilterCount();

            if (hasChanges && window.innerWidth >= 992 && window.ASP?.api) {
                window.ASP.api(aspId, 'search');
            }
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && filtersAside.getAttribute('aria-hidden') === 'false') {
            closeFilters();
        }
    });

    const initLoadState = () => {
        let hasChecked = false;

        filterInputs.forEach(input => {
            const value = input.value;

            // Corrige o bug de carregamento inicial usando a mesma lógica do syncWithASP
            let taxSlug = input.name.replace('termset_', '').replace('[]', '');
            let aspInput = aspContainer.querySelector(`input[name*="${taxSlug}"][value="${value}"]`);

            if (!aspInput) {
                const aspTaxContainer = aspContainer.querySelector(`[class*="${taxSlug}"]`);
                if (aspTaxContainer) {
                    aspInput = aspTaxContainer.querySelector(`input[value="${value}"]`);
                }
            }

            if (aspInput && aspInput.checked) {
                input.checked = true;
                hasChecked = true;
            }
        });

        if (hasChecked) {
            updateFilterCount();

            filterInputs.forEach(input => {
                if (input.checked) {
                    const panel = input.closest('.c-filters__panel');
                    if (panel && !panel.classList.contains('is-open')) {
                        panel.classList.add('is-open');
                        const btn = panel.querySelector('.c-filters__accordion-btn');
                        if (btn) btn.setAttribute('aria-expanded', 'true');
                    }
                }
            });
        }
    };

    initLoadState();
}
